import { completeReducer, completeState, createReducer } from 'redux-recompose';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

const stateDescription = {
  description: {
    permissions: []
  }
};

export const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [actions.GET_PERMISSIONS],
  override: {}
};

export default createReducer(
  Immutable(initialState),
  completeReducer(reducerDescription)
);
